// Mesma regra do servidor (Funnel#terminal_stage_kind): só a etiqueta visível.
export const terminalStageKind = (funnel, stageKey) => {
  const config = funnel?.stages?.[stageKey];
  if (!config) return null;
  const visible = String(config.label || config.name || '').toLowerCase();
  if (visible.includes('ganh') || visible.includes('won')) return 'won';
  if (visible.includes('perd') || visible.includes('lost')) return 'lost';
  return null;
};
